import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

// KB Feedback Widget — thumbs up/down with AJAX submit
// data-controller="support--kb-feedback"
export default class extends Controller {
  static targets = ["form", "success", "error"]
  static values = { url: String }

  async submitHelpful() {
    await this._submit(true)
  }

  async submitNotHelpful() {
    await this._submit(false)
  }

  async _submit(helpful) {
    try {
      // FormData, NOT a JSON body: an application/json Content-Type trips
      // Rodauth's json_request? check and gets rejected with 401 before
      // reaching the controller (same failure mode as CONEK-4429).
      // responseKind only sets the Accept header, which Rodauth ignores.
      const body = new FormData()
      body.append("helpful", helpful)
      const response = await post(this.urlValue, { body, responseKind: "json" })

      if (response.ok) {
        if (this.hasErrorTarget) this.errorTarget.classList.add("hidden")
        this.formTarget.classList.add("hidden")
        this.successTarget.classList.remove("hidden")
      } else {
        await this._showError(response)
      }
    } catch (e) {
      console.error("[kb-feedback] Submit failed:", e)
      this._showError(null)
    }
  }

  // Surface the server's message (e.g. duplicate vote) instead of failing
  // silently; the template carries a generic fallback message.
  async _showError(response) {
    if (!this.hasErrorTarget) return

    try {
      const data = await response?.json
      if (data?.message) this.errorTarget.textContent = data.message
    } catch {
      // keep the template's fallback message
    }
    this.errorTarget.classList.remove("hidden")
  }
}
